"use client";

import React, { useEffect, useRef, useState } from "react";
import Header from "../header/page";
import Button from "../../components/Button/button";
import { getAvailableSubscriptions } from "../botb-pass/subscription-service";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { DEVICE_RESOLUTION } from "../../app-constants";
import { checkIfUserIsAlreadySubsribed, createPaySession, updatePaySession } from "./subscription-checkout-service";
import FeaturedCompetitions from "../header/featuredCompetitions";
import { validateEmail } from "../../common-utils";
import "./subscription-checkout.css";
import { toast } from "react-toastify";
import ToastNotification from "../../components/ToastNotification/toastNotification";
import {
  appendSourceParameter,
  formatBillingPeriodForGTM,
  pushQueueToDataLayer,
  sendEvent,
} from "../../../gtm/functions";
import { IGTMEventType } from "../../../gtm/IGTMEventType";
import { setCookie } from "../../../helpers/cookies";
import ChevronDownIcon from "../../shared-components/icons/ChevronDownIcon";
import PayComIFrame from "@/app/checkout/components/PayComIFrame";
import TrustlyBonusSection from "@/app/(general-header)/subscription-checkout/TrustlyBonusSection";

const SubscriptionCheckout = () => {
  /* reading values from Razor view */
  const [clientSecret, setClientSecret] = useState<string>();
  let isUserAuthenticated = false;
  const isUpsell = window.location.search.includes("upsell=true");
  const userAuthenticatedNode = document.querySelector("#user-athenticated");
  if (userAuthenticatedNode) {
    isUserAuthenticated = userAuthenticatedNode.textContent === "True";
  }
  let merchantId = "";
  const merchantIdNode = document.querySelector("#merchant-Id");
  if (merchantIdNode) {
    merchantId = merchantIdNode.textContent;
  }
  let termsAndConditions = "";
  const tAndCNode = document.querySelector("#terms-and-conditions");
  if (tAndCNode) {
    termsAndConditions = tAndCNode.textContent;
  }
  let paymentPartners: string;
  const paymentPartnersNode = document.querySelector("#payment-partners");
  if (paymentPartnersNode) {
    const template = document.createElement("temp-template");
    template.innerHTML = paymentPartnersNode.textContent;
    paymentPartners = template.innerHTML;
  }
  let selectedPlan: Price;
  const urlParams = new URLSearchParams(window.location.search);
  let selectedFrequencyPlanId = urlParams.get("packageId");

  let isLiveServer = false;
  const liveServerCheckNode = document.querySelector("#live-server-check");
  if (liveServerCheckNode) {
    isLiveServer = liveServerCheckNode.textContent === "True";
  }

  let isFacebookSubscribeEventEnabled = true;
  const facebookSubscribeEventEnabledCheckNode = document.querySelector(
    "#enable-facebook-purchase-and-subscribe-tracking"
  );
  if (facebookSubscribeEventEnabledCheckNode) {
    isFacebookSubscribeEventEnabled = facebookSubscribeEventEnabledCheckNode.textContent === "True";
  }

  let preTermsAndConditions = "";
  const preTAndCNode = document.querySelector("#pre-checkout-terms-and-conditions");
  if (preTAndCNode) {
    preTermsAndConditions = preTAndCNode.textContent;
  }

  let yearlyTermsAndConditions = "";
  const yearlyTAndCNode = document.querySelector("#yearly-terms-and-conditions");
  if (yearlyTAndCNode) {
    yearlyTermsAndConditions = yearlyTAndCNode.textContent;
  }

  let yearlyPreTermsAndConditions = "";
  const yearlyPreTAndCNode = document.querySelector("#yearly-pre-checkout-terms-and-conditions");
  if (yearlyPreTAndCNode) {
    yearlyPreTermsAndConditions = yearlyPreTAndCNode.textContent;
  }

  let userEmailString = "";
  const userEmailNode = document.querySelector("#userEmail");
  if (userEmailNode) {
    userEmailString = userEmailNode.textContent;
  }

  /* component state variables */
  const [packageData, setpackageData] = useState<Package>({
    name: "",
    productId: "",
    features: [],
    metadata: [],
    description: "",
    image: "",
    prices: [],
  });
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [currentFrequencyPlan, setCurrentFrequencyPlan] = useState<Price>({
    interval: "",
    id: "",
    currency: "",
    unit_amount: 0,
    intervalCount: 0,
    isActive: false,
    metadata: {},
  });
  const [isYearlySwitchOn, setIsYearlySwitchOn] = useState(false);
  const [frequencyPlanSelectedOnSubscriptionPage, setFrequencyPlanSelectedOnSubscriptionPage] = useState<Price>();
  const frequencyPlanSelected = useRef<Price>(currentFrequencyPlan);
  const selectedPackageFromSubscriptionPage = useRef<Package>(packageData);
  const [windowInnerWidth, setWindowInnerWidth] = useState<number>(window.innerWidth);
  const [showPlanFullDetails, setShowFullPlanDetails] = useState(false);
  const [showPayComIFrame, setShowPayComIFrame] = useState(isUserAuthenticated);
  const [userEmail, setUserEmail] = useState<string>(userEmailString);
  const [isPaymentDone, setIsPaymentDone] = useState<boolean>(false);
  const [showOrderDetails, setShowOrderDetails] = useState<boolean>(false);
  const paymentId = useRef<string>();
  const [paySessionError, setPaySessionError] = useState<string>("");
  const [isEmailValid, setIsEmailValid] = useState<boolean>(true);
  const [activeSubscriptionError, setActiveSubscriptionError] = useState<string>("");
  const [shouldShowLoginLink, setShouldShowLoginLink] = useState(false);
  const monthlyPlan = packageData?.prices?.find(price => price.interval === "month");
  const showDebugMessage = false;

  // Swap the T&C copy based on the selected billing interval. Fall back to the
  // monthly (default) copy when the yearly field has not been filled in Umbraco.
  const isYearlyInterval = currentFrequencyPlan?.interval === "year";
  const activeTermsAndConditions = isYearlyInterval
    ? yearlyTermsAndConditions || termsAndConditions
    : termsAndConditions;
  const activePreTermsAndConditions = isYearlyInterval
    ? yearlyPreTermsAndConditions || preTermsAndConditions
    : preTermsAndConditions;
  const [isPaymentCheckoutLoading, setIsPaymentCheckoutLoading] = useState(false);
  const [isPaymentFormLoading, setIsPaymentFormLoading] = useState<boolean>(false);
  const [payComResyncCallback, setPayComResyncCallback] = useState<() => void>(null);
  const [isSumitButtonBusy, setIsSumitButtonBusy] = useState<boolean>(false);
  const [submitPaymentFlag, setSubmitPaymentFlag] = useState<boolean>(false);
  const [resyncPaymentFlag, setResyncPaymentFlag] = useState<boolean>(false);
  const [payComIframeData, setPayComIframeData] = useState<any>(null);
  const [shouldSubmitApplyPayPayment, setShouldSubmitApplyPayPayment] = useState<boolean>(false);
  const [shouldSubmitGooglePayPayment, setShouldSubmitGooglePayPayment] = useState<boolean>(false);
  const [shouldSubmitTrustlyPayment, setShouldSubmitTrustlyPayment] = useState<boolean>(false);
  const [shouldSubmitPayPalPayment, setShouldSubmitPayPalPayment] = useState<boolean>(false);
  const [shouldSubmitMobilePayment, setShouldSubmitMobilePayment] = useState<boolean>(false);
  const [shouldSubmitBankAccountPayment, setShouldSubmitBankAccountPayment] = useState<boolean>(false);
  const [shouldShowApplePayButton, setShouldShowApplePayButton] = useState<boolean>(false);
  const [shouldShowTrustlyPayButton, setShouldShowTrustlyPayButton] = useState<boolean>(false);
  const [shouldShowGooglePayButton, setShouldShowGooglePayButton] = useState<boolean>(false);
  const failureRef = useRef<boolean>(false);
  const [bonusCode, setBonusCode] = useState<string>("");
  const [showBonusCode, setShowBonusCode] = useState<boolean>(false);
  const [showDirectDebitModal, setDirectDebitModal] = useState<boolean>(false);
  const [isTrustlyBonusEligible, setIsTrustlyBonusEligible] = useState<boolean>(false);
  const [trustlyBonusDays, setTrustlyBonusDays] = useState<number | undefined>(undefined);
  useEffect(pushQueueToDataLayer, []);
  const [expandedElement, setExpandedElement] = useState<string | null>(null);
  const toggleExpand = (element: string) => {
    if (expandedElement === element) {
      setExpandedElement(null);
    } else {
      setExpandedElement(element);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const ensureAbsolutePath = (path: string) => {
    if (path && !path.startsWith("http")) {
      path = process.env.NEXT_PUBLIC_HOST + path;
    }
    return path;
  };

  useEffect(() => {
    getPackageDetails();
    renderRespectiveLayout();
    window.addEventListener("resize", renderRespectiveLayout);
    return () => {
      window.removeEventListener("resize", renderRespectiveLayout);
    };
  }, []);

  const renderRespectiveLayout = () => {
    setWindowInnerWidth(window.innerWidth);
  };

  const checkForUserSubscription = async () => {
    try {
      const subscriptionResponse = await checkIfUserIsAlreadySubsribed(userEmail);
      const { IsUserAlreadySubscribed } = (await subscriptionResponse.json()) as {
        IsUserAlreadySubscribed: boolean;
      };
      if (IsUserAlreadySubscribed) {
        setIsPaymentDone(true);
      } else {
        if (showPayComIFrame) {
          createPayComIFrame(frequencyPlanSelected.current?.id);
        }
      }
    } catch (error) {
      console.error(`Error while fetching user's subscriptions - ${JSON.stringify(error)}`);
    }
  };

  // on component mount
  const getPackageDetails = async () => {
    try {
      const response = await getAvailableSubscriptions();
      const subscriptionPackages = (await response.json()) as Package[];
      const selectedPackage = subscriptionPackages.find(subscription => {
        selectedPlan = subscription.prices.find(price => price.id === selectedFrequencyPlanId);
        if (selectedPlan) {
          return true;
        }
        return false;
      });
      setFrequencyPlanSelectedOnSubscriptionPage(selectedPlan);
      frequencyPlanSelected.current = selectedPlan;
      setpackageData(selectedPackage);
      selectedPackageFromSubscriptionPage.current = selectedPackage;
      setCurrentFrequencyPlan(selectedPlan);
      checkForUserSubscription();
    } catch (error) {
      console.error(`Error while retrieving subscriptions - ${JSON.stringify(error)}`);
    } finally {
      setIsLoading(false);
    }
  };

  const getYearlyMonthlyPriceCardValue = () => {
    const yearlyPriceData = packageData.prices.find(price => price.interval === "year");
    if (yearlyPriceData) {
      return yearlyPriceData.metadata["monthly_price_card"];
    }
    return "£0";
  };
  const togglePlanFrequency = async () => {
    if (isPaymentCheckoutLoading) {
      return;
    }
    setIsPaymentCheckoutLoading(true);
    const previousPlanInterval = currentFrequencyPlan.interval;
    const newFrequencyPlan = packageData.prices.find(
      price => typeof price.interval !== "undefined" && price.interval !== previousPlanInterval
    );
    setCurrentFrequencyPlan(newFrequencyPlan);
    frequencyPlanSelected.current = newFrequencyPlan;
    setIsYearlySwitchOn(isOn => !isOn);
    sendEvent(
      isUpsell ? IGTMEventType.SubscriptionUpsellCheckoutStart : IGTMEventType.SubscriptionCheckoutStart,
      appendSourceParameter(isUpsell, {
        plan_id: selectedPackageFromSubscriptionPage.current.name.toLowerCase(),
        price: frequencyPlanSelected.current.unit_amount / 100,
        billing_period: formatBillingPeriodForGTM(frequencyPlanSelected.current.interval),
      })
    );
    if (showPayComIFrame) {
      try {
        setIsPaymentCheckoutLoading(true);
        await onUpdatePaySession(newFrequencyPlan.id);
        setResyncPaymentFlag(true);
        setIsPaymentCheckoutLoading(false);
      } catch (err) {
        console.error(err);
      }
    } else {
      setIsPaymentCheckoutLoading(false);
    }
  };

  const getTotalPaidDetails = () => (
    <div className="flex justify-between text-[rgba(26,26,26,0.90)]">
      <span className="lg:text-[16px] xs:text-[14px] lg:font-semibold xs:font-medium">
        Total {!isPaymentDone ? "due" : "paid"} today
      </span>
      <span className="lg:text-[24px] xs:text-[16px] font-semibold">£{currentFrequencyPlan?.unit_amount / 100}</span>
    </div>
  );

  const getPlanPriceDetails = () => (
    <>
      <div className="flex justify-between text-[rgba(26,26,26,0.90)] lg:text-base xs:text-sm mt-6">
        <span className="lg:font-semibold xs:font-medium">Subtotal</span>
        <span className="font-semibold">£{currentFrequencyPlan?.unit_amount / 100}</span>
      </div>
      <hr className="bg-[rgba(0,0,0,0.08)] my-4" />
      {getTotalPaidDetails()}
    </>
  );

  const bonusCodeHtml = () => {
    return (
      <div className="w-full lg:bg-[#F6F6F6] mt-6 lg:px-5 lg:py-[9px] lg:rounded-lg lg:mt-12">
        <button
          onClick={() => {
            if (showBonusCode) {
              setBonusCode("");
            }
            setShowBonusCode(!showBonusCode);
          }}
          className="flex w-full items-center gap-1 lg:justify-between">
          <div className="text-gray-1 font-jost text-sm underline lg:text-base lg:font-normal lg:leading-5.5">
            I have a code
          </div>
          <ChevronDownIcon
            className={`size-5 shrink-0 text-gray-500 transition-transform duration-200 ${
              showBonusCode ? "rotate-180" : ""
            }`}
          />
        </button>

        <div
          className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
            showBonusCode ? "max-h-40" : "max-h-0"
          }`}>
          <div className="text-gray-600 text-sm pt-3 lg:pt-4 lg:pb-[11px]">
            <input
              type="text"
              name="bonuscode"
              autoComplete="off"
              value={bonusCode}
              onChange={e => setBonusCode(e.target.value)}
              className={`flex w-full h-12 justify-end items-center bg-white border border-[#E0E0E0] outline-0 pl-3 pr-2 py-4 rounded-md text-sm font-normal leading-normal text-dark-1 autofill-fix`}
              placeholder={bonusCode.length === 0 && "Insert your code here"}
            />
          </div>
        </div>
      </div>
    );
  };

  const onUserEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputElement = e?.target as HTMLInputElement;
    if (inputElement) {
      setActiveSubscriptionError("");
      setShouldShowLoginLink(false);
      setIsEmailValid(validateEmail(inputElement.value));
      setUserEmail(inputElement.value);
    }
  };

  const onContinueCheckout = async (event: React.MouseEvent<HTMLButtonElement>) => {
    // preventing browser reload on form submit using event.preventDefault()
    event.preventDefault();
    try {
      // Reset state
      setShouldShowLoginLink(false);
      sendEvent(
        isUpsell ? IGTMEventType.SubscriptionUpsellEmailSubmitted : IGTMEventType.SubscriptionEmailSubmitted,
        appendSourceParameter(isUpsell, {
          plan_id: selectedPackageFromSubscriptionPage.current.name.toLowerCase(),
          price: currentFrequencyPlan.unit_amount / 100,
          billing_period: formatBillingPeriodForGTM(currentFrequencyPlan.interval),
        })
      );
      setShowPayComIFrame(true);
      createPayComIFrame(currentFrequencyPlan?.id);
    } catch (error) {
      console.error(`Error while retreiving whether user is subscribed or not`, error);
    }
  };

  const getUserEmailInputView = () => (
    <>
      <form className="w-full">
        <label className="text-gray-1 text-sm font-medium w-full flex flex-col">
          <span className={"text-[0.625rem] lg:text-sm leading-none text-gray-1 font-medium uppercase"}>Email</span>
          <input
            id="user-email"
            type="email"
            className="font-normal leading-normal mt-2 lg:mt-3 w-full h-[2.75rem] lg:h-[56px] flex items-center justify-center py-2 lg:pt-5 lg:pb-[19.5px] px-3 rounded-[6px] bg-white shadow-[0_0_0_1px_#E0E0E0] focus-visible:outline-none"
            value={userEmail}
            onChange={onUserEmailChange}
            onFocus={() =>
              sendEvent(
                isUpsell ? IGTMEventType.SubscriptionUpsellEmailEntry : IGTMEventType.SubscriptionEmailEntry,
                appendSourceParameter(isUpsell, {
                  plan_id: selectedPackageFromSubscriptionPage.current.name.toLowerCase(),
                  price: currentFrequencyPlan.unit_amount / 100,
                  billing_period: formatBillingPeriodForGTM(currentFrequencyPlan.interval),
                })
              )
            }
            placeholder="email@example.com"
            title="Please enter a valid email address"
          />
          {activeSubscriptionError !== "" && (
            <span className="text-red-500 mt-1 text-sm font-normal block">{activeSubscriptionError}</span>
          )}

          {shouldShowLoginLink && (
            <a
              href="/login"
              className="flex justify-center items-center text-white bg-[#FF8200] rounded p-4 mt-10 mb-4 btnWithArrow w-full font-jost text-[18px] font-medium normal-case">
              Login
            </a>
          )}

          {!isEmailValid && (
            <span className="text-red-500 mt-1 text-sm font-normal block">Please use a valid email address.</span>
          )}
          {paySessionError !== "" && (
            <div className="flex flex-col mt-[15px]">
              {paySessionError.split(",").map(error => (
                <span key={error} className="text-red-500 text-sm font-normal">
                  {error}
                </span>
              ))}
            </div>
          )}
        </label>
        {!shouldShowLoginLink && (
          <Button
            className="flex justify-center items-center text-white bg-[#FF8200] rounded px-4 py-2.5 mt-10 btnWithArrow w-full leading-[1.75rem] font-jost text-lg font-medium"
            onClick={onContinueCheckout}
            isDisabled={!isEmailValid}
            type="submit"
            text="">
            <span className="relative flex items-center gap-2">
              Continue
              <span className={"relative size-5"}>
                <svg
                  className="absolute inset-0 size-5 arrowImage"
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none">
                  <g clipPath="url(#clip0_28904_2574)">
                    <path
                      d="M6.33398 5.83301L10.5007 9.99967L6.33398 14.1663"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M11.334 5.83301L15.5007 9.99967L11.334 14.1663"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_28904_2574">
                      <rect width="20" height="20" fill="white" transform="translate(0.5)" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </span>
          </Button>
        )}
      </form>
      <div className="flex gap-8 w-full justify-center mt-3 flex-col">
        <div
          className={"text-xs font-normal text-gray-1 text-center"}
          dangerouslySetInnerHTML={{ __html: activePreTermsAndConditions }}
        />
        <div className="flex gap-2 justify-center text-sm leading-4 text-gray-1">
          Already have a BOTB account?
          <a className="text-[#3772FF] font-medium underline" href="/login">
            Log in here
          </a>
        </div>
      </div>
    </>
  );

  const createPayComIFrame = async (selectedPlanId: string) => {
    try {
      setIsPaymentCheckoutLoading(true);
      const response = await createPaySession(selectedPlanId, userEmail);
      const data = await response.json();
      // if session can not be created by Pay.com
      if (data.statusCode !== undefined && data.statusCode !== 201) {
        handlePaySessionError(data);
      } else {
        setPayComIframeData(data);
        setIsTrustlyBonusEligible(Boolean(data.isTrustlyBonusEligible));
        setTrustlyBonusDays(
          typeof data.trustlyBonusDays === "number" && data.trustlyBonusDays > 0 ? data.trustlyBonusDays : undefined
        );
        setIsPaymentCheckoutLoading(false);
        paymentId.current = data.metadata.payment_id;
        setClientSecret(data.client_secret);
      }
    } catch (error) {
      console.error(`Error while creating pay session - ${JSON.stringify(error)}`);
    }
  };

  const handlePaySessionError = (error: any) => {
    let message = error.message.map((m: string) => m).join(",");
    setPaySessionError(message);
  };

  const onUpdatePaySession = async (packageId?: string) => {
    const response = await updatePaySession(paymentId.current, packageId ?? currentFrequencyPlan.id);
    const updatePaySessionResponse = await response.json();
    setIsTrustlyBonusEligible(Boolean(updatePaySessionResponse.isTrustlyBonusEligible));
    setTrustlyBonusDays(
      typeof updatePaySessionResponse.trustlyBonusDays === "number" && updatePaySessionResponse.trustlyBonusDays > 0
        ? updatePaySessionResponse.trustlyBonusDays
        : undefined
    );
  };

  const handleCheckoutSubmitButtonClicked = async () => {
    failureRef.current = false;
    if (showBonusCode && bonusCode.length > 0) {
      const regexTest = /^[A-Za-z0-9]+$/;
      if (!regexTest.test(bonusCode)) {
        toast.warning(<ToastNotification message="Bonus code must be only letters or numbers." />);
        return;
      } else {
        setCookie("utm_voucher", { cookieValue: bonusCode, secure: true });
        setIsPaymentCheckoutLoading(true);
        await onUpdatePaySession();
        setResyncPaymentFlag(true);
        setIsPaymentCheckoutLoading(false);
      }
    } else {
      setShowBonusCode(false);
      setBonusCode("");
    }

    try {
      setSubmitPaymentFlag(true);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const onCanMakePaymentResultCallback = (data: any) => {
    if (data) {
      if (data.applepay) {
        // Show Apple Pay button if available
        setShouldShowApplePayButton(true);
      }

      if (data.googlepay) {
        // Show Google Pay button if available
        setShouldShowGooglePayButton(true);
      }
    }
  };

  const onGetPaymentMethodsResultCallback = (data: any) => {
    if (data) {
      if (Array.isArray(data) && data.find(item => item.paymentMethodType === "trustly")) {
        // Show Trustly button if available
        setShouldShowTrustlyPayButton(true);
      }
    }
  };

  const onPaymentBeforeInitCallback = () => {
    if (showDebugMessage) {
      console.log("onPaymentBeforeInitCallback");
    }

    setIsPaymentCheckoutLoading(true);
  };

  const onPaymentContentReadyCallback = (data: any) => {
    if (showDebugMessage) {
      console.log("onPaymentContentReadyCallback");
    }
    sendEvent(
      isUpsell ? IGTMEventType.SubscriptionUpsellCheckoutStart : IGTMEventType.SubscriptionCheckoutStart,
      appendSourceParameter(isUpsell, {
        plan_id: selectedPackageFromSubscriptionPage.current.name.toLowerCase(),
        price: frequencyPlanSelected.current.unit_amount / 100,
        billing_period: formatBillingPeriodForGTM(frequencyPlanSelected.current.interval),
      })
    );
    setIsPaymentCheckoutLoading(false);
  };

  const onPaymentSuccessfulCallback = (data: any) => {
    if (showDebugMessage) {
      console.log("onPaymentSuccessfulCallback");
      console.log(data);
    }
    sendEvent(
      isUpsell ? IGTMEventType.SubscriptionUpsellPaymentCompleted : IGTMEventType.SubscriptionPaymentCompleted,
      appendSourceParameter(isUpsell, {
        plan_id: selectedPackageFromSubscriptionPage.current.name.toLowerCase(),
        price: frequencyPlanSelected.current.unit_amount / 100,
        billing_period: formatBillingPeriodForGTM(frequencyPlanSelected.current.interval),
      })
    );
    setIsPaymentDone(true);
    facebookTrackingEvent();
  };

  const onPaymentFailedCallback = (data: any) => {
    if (showDebugMessage) {
      console.log("onPaymentFailedCallback");
      console.log(data);
    }
    if (failureRef.current) return;
    failureRef.current = true;

    setIsSumitButtonBusy(false);
    setSubmitPaymentFlag(false);
    setIsPaymentFormLoading(false);

    setShouldSubmitApplyPayPayment(false);
    setShouldSubmitGooglePayPayment(false);
    setShouldSubmitTrustlyPayment(false);
    setShouldSubmitPayPalPayment(false);
    setShouldSubmitMobilePayment(false);
    setShouldSubmitBankAccountPayment(false);

    sendEvent(
      isUpsell ? IGTMEventType.SubscriptionUpsellPaymentFailed : IGTMEventType.SubscriptionPaymentFailed,
      appendSourceParameter(isUpsell, {
        plan_id: selectedPackageFromSubscriptionPage.current.name.toLowerCase(),
        price: frequencyPlanSelected.current.unit_amount / 100,
        billing_period: formatBillingPeriodForGTM(frequencyPlanSelected.current.interval),
        failure_reason: data?.data?.declineCode,
        error_code: data?.data?.code,
      })
    );
    // toastId prevents a second identical toast if Pay.com fires PAYMENT_FAILURE twice
    // (e.g. Trustly cancel). Do not add another ToastProvider on this page — Header owns it.
    if (data !== null && data.message) {
      toast.error(<ToastNotification message={`Checkout failed: ${data?.message}`} />, {
        toastId: "subscription-checkout-payment-failed",
      });
    } else {
      toast.error(<ToastNotification message="Checkout failed: Please try again" />, {
        toastId: "subscription-checkout-payment-failed",
      });
    }
  };

  const onPaymentProcessingCallback = (data: any) => {
    if (showDebugMessage) {
      console.log("onPaymentProcessingCallback");
    }
    failureRef.current = false;
    sendEvent(
      isUpsell ? IGTMEventType.SubscriptionUpsellPaymentAttempt : IGTMEventType.SubscriptionPaymentAttempt,
      appendSourceParameter(isUpsell, {
        plan_id: selectedPackageFromSubscriptionPage.current.name.toLowerCase(),
        price: frequencyPlanSelected.current.unit_amount / 100,
        billing_period: formatBillingPeriodForGTM(frequencyPlanSelected.current.interval),
      })
    );
  };

  const onPaymentResyncCallback = (data: any) => {
    if (showDebugMessage) {
      console.log("onPaymentResyncCallback");
    }
    setIsPaymentCheckoutLoading(false);
    setResyncPaymentFlag(false);

    if (payComResyncCallback) {
      payComResyncCallback();
      setPayComResyncCallback(null);
    }
  };

  const onPaymentValidationCallback = (data: any) => {
    if (showDebugMessage) {
      console.log("onPaymentValidatedCallback");
      console.log(data);
    }

    if (!data) {
      setIsSumitButtonBusy(false);
      setSubmitPaymentFlag(false);
    }
  };

  const startApmPayment = (start: () => void) => {
    failureRef.current = false;
    toast.dismiss("subscription-checkout-payment-failed");
    start();
  };

  const getCheckoutSubmitButton = () => {
    let submitButtonText = `SUBSCRIBE FOR £${currentFrequencyPlan?.unit_amount / 100}`;

    if (isSumitButtonBusy) {
      return (
        <>
          {/* Show loading animation */}
          <img
            alt="Loading"
            className={"mx-[auto] my-[10px] w-[50px] h-[50px]"}
            src={ensureAbsolutePath("/assets/images/prize-loader.webp")}
          />
        </>
      );
    } else {
      return (
        <>
          <button
            type="submit"
            id="submitbutton"
            onClick={() => handleCheckoutSubmitButtonClicked()}
            className={"bg-primary rounded h-12 flex-center text-center w-full"}>
            <span className={"uppercase text-white font-medium text-lg leading-6"}>{submitButtonText}</span>
          </button>
        </>
      );
    }
  };

  const getPaymentIFrameView = () => {
    return (
      <>
        <PayComIFrame
          merchantId={payComIframeData?.metadata?.payment_id}
          paymentSessionId={clientSecret}
          isProductionEnvironment={isLiveServer}
          cssClass={``}
          shouldSubmitPayment={submitPaymentFlag}
          shouldResync={resyncPaymentFlag}
          shouldUseHeadlessMode={true}
          shouldSubmitApplyPayPayment={shouldSubmitApplyPayPayment}
          shouldSubmitGooglePayPayment={shouldSubmitGooglePayPayment}
          shouldSubmitTrustlyPayment={shouldSubmitTrustlyPayment}
          shouldSubmitPayPalPayment={shouldSubmitPayPalPayment}
          shouldSubmitMobilePayment={shouldSubmitMobilePayment}
          shouldSubmitBankAccountPayment={shouldSubmitBankAccountPayment}
          onCanMakePaymentResultCallback={onCanMakePaymentResultCallback}
          onGetPaymentMethodsResultCallback={onGetPaymentMethodsResultCallback}
          onPaymentBeforeInitCallback={onPaymentBeforeInitCallback}
          onPaymentContentReadyCallback={onPaymentContentReadyCallback}
          onPaymentSuccessfulCallback={onPaymentSuccessfulCallback}
          onPaymentProcessingCallback={onPaymentProcessingCallback}
          onPaymentFailedCallback={onPaymentFailedCallback}
          onPaymentResyncCallback={onPaymentResyncCallback}
          onPaymentValidationCallback={onPaymentValidationCallback}
        />
      </>
    );
  };

  const getHeadlessPaymentView = () => {
    return (
      <>
        <div className={"font-jost"}>
          <div className={"text-secondary text-xs lg:text-sm leading-4 lg:leading-5 font-medium mb-3"}>
            Select a payment method
          </div>
          {/*#method Trustly*/}
          {shouldShowTrustlyPayButton && (
            <>
              <div
                onClick={() => toggleExpand("trustly")}
                className={
                  "mb-3 lg:mb-6 rounded-lg border border-black/16 py-4 pt-7 lg:pt-9 lg:py-5 cursor-pointer relative"
                }>
                {/*visible*/}
                <div
                  className={
                    "bg-[#CBF4C9] text-[#1C5020] absolute -top-px -left-px rounded-tl-lg rounded-br-lg text-center z-10 text-xs lg:text-[13px] leading-4 lg:leading-4.5 font-normal py-[3px] lg:py-1 px-3"
                  }>
                  Recommended
                </div>
                <div className={"flex items-center px-3 lg:px-6"}>
                  <div className={""}>
                    <div className={"text-dark-1 text-sm lg:text-lg leading-5 lg:leading-6 font-medium mb-0.5"}>
                      Direct Debit
                    </div>
                    <div className={"font-roboto text-[#898994] text-xs text-[13px] font-normal"}>
                      With our partner Trustly
                    </div>
                  </div>
                  <div className={"ml-auto mr-3"}>
                    <img
                      alt="trustly-logo"
                      className="shrink-0 w-[72px] lg:w-[83px] h-[29px] lg:h-[33px]"
                      src="/assets/images/subscription-checkout/trustly-logo.svg"
                      width={72}
                      height={29}
                    />
                  </div>
                  <div
                    className={`transition-transform duration-400 ${expandedElement === "trustly" ? "rotate-180" : "rotate-0"}`}>
                    <img
                      alt="chevron-down"
                      src="/assets/images/subscription-checkout/chevron-down.svg"
                      className={"size-4"}
                      width={16}
                      height={16}
                    />
                  </div>
                </div>
                {/*expand*/}
                <div
                  className={`px-3 lg:px-6 transition-all duration-400 ease-in-out overflow-hidden ${expandedElement === "trustly" ? "opacity-100 max-h-[1600px] pt-6 lg:pt-8 mt-4 border-t border-black/8" : "opacity-0 max-h-0 pt-0 mt-0 border-0"}`}>
                  <TrustlyBonusSection
                    isTrustlyBonusEligible={isTrustlyBonusEligible}
                    trustlyBonusDays={trustlyBonusDays}
                    unitAmount={currentFrequencyPlan?.unit_amount}
                    interval={currentFrequencyPlan?.interval}
                  />
                  <div>
                    {/*#1*/}
                    <div className={"mb-4 lg:mb-6 text-[#696971] leading-4 text-xs lg:text-[13px] font-normal"}>
                      <div className={"mb-2 flex items-center gap-2"}>
                        <img
                          alt="tabler-icon-check"
                          src="/assets/images/subscription-checkout/tabler-icon-check.svg"
                          className={"size-4"}
                          width={16}
                          height={16}
                        />
                        <div>No forms to fill in, no card needed</div>
                      </div>
                      <div className={"flex items-center gap-2"}>
                        <img
                          alt="tabler-icon-check"
                          src="/assets/images/subscription-checkout/tabler-icon-check.svg"
                          className={"size-4"}
                          width={16}
                          height={16}
                        />
                        <div>Just connect your bank and select an account</div>
                      </div>
                    </div>
                    {/*#2*/}
                    <div className={"mb-4 lg:mb-6"}>
                      <img
                        alt="banks-uk-large"
                        src="/assets/images/subscription-checkout/banks-uk-large.svg"
                        className={"w-[186px] h-auto"}
                        width={186}
                        height={24}
                      />
                    </div>
                    {/*#3*/}
                    <div className={"flex items-center gap-1 mb-6 lg:mb-8"}>
                      <img
                        alt="tabler-icon-info-circle-filled"
                        src="/assets/images/subscription-checkout/tabler-icon-info-circle-filled.svg"
                        className={"size-4"}
                        width={16}
                        height={16}
                      />
                      <div
                        className={"underline text-[#898994] text-xs leading-4 font-normal cursor-pointer"}
                        onClick={e => {
                          e.stopPropagation();
                          setDirectDebitModal(true);
                        }}>
                        Direct Debit Guarantee
                      </div>
                    </div>
                  </div>
                  {/*NEW END*/}
                  <div
                    onClick={() => startApmPayment(() => setShouldSubmitTrustlyPayment(true))}
                    className={
                      "bg-primary rounded h-12 flex-center text-center w-full cursor-pointer relative uppercase text-white font-medium text-lg leading-6"
                    }>
                    {`SUBSCRIBE FOR £${currentFrequencyPlan?.unit_amount / 100}`}
                  </div>
                  <div
                    className={`relative flex w-full mt-3 lg:mt-4 px-1 ${isTrustlyBonusEligible ? "items-start lg:items-center justify-center gap-1" : "items-start justify-center"}`}>
                    <img
                      alt=""
                      aria-hidden="true"
                      className={`size-4 lg:size-5 shrink-0 ${isTrustlyBonusEligible ? "" : "absolute left-1 top-0"}`}
                      height={16}
                      src="/assets/images/subscription-checkout/tabler-icon-clock-hour-3.svg"
                      width={16}
                    />
                    <div
                      className={`text-xs lg:text-sm leading-4 lg:leading-5 font-normal text-gray-5 ${isTrustlyBonusEligible ? "" : "pl-6 text-center"}`}>
                      {isTrustlyBonusEligible
                        ? "Payment and activation can take up to 15 minutes"
                        : "Payment and activation can take up to 5 minutes — your tickets will appear in your account shortly after."}
                    </div>
                  </div>
                  {showPayComIFrame && (
                    <>
                      <div
                        className={"mt-3"}
                        dangerouslySetInnerHTML={{
                          __html: activeTermsAndConditions,
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            </>
          )}
          {showDirectDebitModal && (
            <div className={"fixed inset-0 bg-black/90 flex-center z-[99999999]"}>
              <div className={"bg-white w-[calc(100%-48px)] lg:w-[600px] relative px-4 lg:px-12 py-10 rounded-2xl"}>
                <div
                  onClick={() => setDirectDebitModal(false)}
                  className={"absolute right-3 top-3 z-10 cursor-pointer"}>
                  <img
                    alt="close"
                    src="/assets/images/subscription-checkout/close.svg"
                    className={"size-6"}
                    width={24}
                    height={24}
                  />
                </div>
                <div>
                  <div className={"flex items-center justify-between mb-6"}>
                    <div className={"text-[#28282B] text-base lg:text-xl leading-5.5 lg:leading-6.5 font-semibold"}>
                      Direct Debit Guarantee
                    </div>
                    <div>
                      <img
                        alt="ddg-logo"
                        src="/assets/images/subscription-checkout/ddg-logo.svg"
                        className={"h-4 w-auto"}
                        width={49}
                        height={16}
                      />
                    </div>
                  </div>
                  <div>
                    <ul
                      className={
                        "text-[13px] lg:text-sm text-[#696971] leading-4.5 lg:leading-5 font-normal list-disc pl-4"
                      }>
                      <li className={"mb-3"}>
                        If there are any changes to the amount, date or frequency of your Direct Debit, BOTB will notify
                        you 10 working days in advance of your account being debited or as otherwise agreed.
                      </li>
                      <li className={"mb-3"}>
                        If you request BOTB to collect a payment, confirmation of the amount and date will be given to
                        you at the time of the request.
                      </li>
                      <li className={"mb-3"}>
                        If an error is made in the payment of your Direct Debit, by BOTB or your bank or building
                        society, you are entitled to a full and immediate refund of the amount paid from your bank or
                        building society.
                      </li>
                      <li className={"mb-3"}>
                        If you receive a refund you are not entitled to, you must pay it back when BOTB asks you to.
                      </li>
                      <li>
                        You can cancel a Direct Debit at any time by simply contacting your bank or building society.
                        Written confirmation may be required. Please also notify us.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/*#method Google Pay*/}
          {shouldShowGooglePayButton && (
            <div
              onClick={() => toggleExpand("gpay")}
              className={"mb-3 lg:mb-6 rounded-lg border border-black/16 py-4 lg:py-5 cursor-pointer"}>
              {/*visible*/}
              <div className={"flex items-center px-3 lg:px-6"}>
                <div className={"text-dark-1 text-sm lg:text-lg leading-5 lg:leading-6 font-medium"}>Google Pay</div>
                <div className={"ml-auto mr-3"}>
                  <img
                    alt="google-pay-logo"
                    className={"h-4 lg:h-5 w-auto"}
                    src="/assets/images/subscription-checkout/google-pay-logo.svg"
                    width={40}
                    height={16}
                  />
                </div>
                <div
                  className={`transition-transform duration-400 ${expandedElement === "gpay" ? "rotate-180" : "rotate-0"}`}>
                  <img
                    alt="chevron-down"
                    src="/assets/images/subscription-checkout/chevron-down.svg"
                    className={"size-4"}
                    width={16}
                    height={16}
                  />
                </div>
              </div>
              {/*expand*/}
              <div
                className={`px-3 transition-all duration-400 ease-in-out overflow-hidden ${expandedElement === "gpay" ? "opacity-100 max-h-[1024px] pt-6 mt-4 border-t border-black/8" : "opacity-0 max-h-0 pt-0 mt-0 border-0"}`}>
                <div
                  onClick={() => startApmPayment(() => setShouldSubmitGooglePayPayment(true))}
                  className="flex h-[48px] px-[16px] py-[8px] justify-center items-center gap-[8px] self-stretch rounded-[4px] bg-[#000] cursor-pointer relative">
                  <svg width="52" height="20" viewBox="0 0 52 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M23.9529 9.72589V15.6225H22.0688V1.06128H27.0635C28.3293 1.06128 29.4087 1.48038 30.2919 2.31858C31.1947 3.15677 31.646 4.18015 31.646 5.38871C31.646 6.62651 31.1947 7.64989 30.2919 8.47834C29.4186 9.30679 28.3392 9.71614 27.0635 9.71614H23.9529V9.72589ZM23.9529 2.85463V7.93254H27.1028C27.8485 7.93254 28.4765 7.67913 28.9672 7.18206C29.4676 6.68499 29.7227 6.08071 29.7227 5.39846C29.7227 4.72595 29.4676 4.13142 28.9672 3.63435C28.4765 3.11779 27.8583 2.86438 27.1028 2.86438H23.9529V2.85463Z"
                      fill="white"
                    />
                    <path
                      d="M36.5718 5.33081C37.9652 5.33081 39.0642 5.70118 39.8689 6.44191C40.6735 7.18264 41.0758 8.19627 41.0758 9.48281V15.6231H39.2801V14.2391H39.2016C38.4264 15.3794 37.3862 15.9447 36.091 15.9447C34.9821 15.9447 34.0597 15.6231 33.314 14.9701C32.5682 14.3171 32.1953 13.5081 32.1953 12.5334C32.1953 11.5003 32.5878 10.6816 33.3728 10.0773C34.1579 9.46331 35.2078 9.16117 36.5129 9.16117C37.6316 9.16117 38.554 9.36585 39.2703 9.7752V9.34635C39.2703 8.69334 39.0152 8.14754 38.4951 7.68945C37.975 7.23137 37.3666 7.0072 36.6699 7.0072C35.62 7.0072 34.7859 7.44579 34.1775 8.33272L32.5191 7.2996C33.4317 5.98382 34.7859 5.33081 36.5718 5.33081ZM34.1382 12.5627C34.1382 13.05 34.3443 13.4594 34.7662 13.781C35.1784 14.1026 35.669 14.2683 36.2283 14.2683C37.0232 14.2683 37.7297 13.9759 38.3479 13.3911C38.9661 12.8063 39.2801 12.1241 39.2801 11.3346C38.6913 10.8766 37.8769 10.6426 36.8269 10.6426C36.0615 10.6426 35.4237 10.8278 34.9134 11.1884C34.3934 11.5686 34.1382 12.0266 34.1382 12.5627Z"
                      fill="white"
                    />
                    <path
                      d="M51.3206 5.65308L45.0404 19.9999H43.0975L45.433 14.9804L41.292 5.65308H43.3428L46.3259 12.807H46.3652L49.2697 5.65308H51.3206Z"
                      fill="white"
                    />
                    <path
                      d="M16.4591 8.53659C16.4591 7.92646 16.4041 7.34265 16.302 6.78125H8.40479V9.99758L12.953 9.99856C12.7685 11.0687 12.1748 11.981 11.2652 12.5892V14.6759H13.9725C15.5533 13.2227 16.4591 11.0746 16.4591 8.53659Z"
                      fill="#4285F4"
                    />
                    <path
                      d="M11.2661 12.5905C10.5125 13.0954 9.54198 13.3907 8.40665 13.3907C6.21351 13.3907 4.35302 11.9229 3.68674 9.94434H0.894043V12.0964C2.27763 14.8234 5.12136 16.6947 8.40665 16.6947C10.6773 16.6947 12.5849 15.953 13.9734 14.6763L11.2661 12.5905Z"
                      fill="#34A853"
                    />
                    <path
                      d="M3.42365 8.3481C3.42365 7.79255 3.51687 7.25552 3.68663 6.75065V4.59863H0.893936C0.321855 5.7263 0 6.99919 0 8.3481C0 9.69701 0.322836 10.9699 0.893936 12.0976L3.68663 9.94555C3.51687 9.44068 3.42365 8.90365 3.42365 8.3481Z"
                      fill="#FABB05"
                    />
                    <path
                      d="M8.40665 3.30405C9.64599 3.30405 10.7558 3.72802 11.6321 4.55647L14.0313 2.17541C12.5741 0.827476 10.6744 0 8.40665 0C5.12234 0 2.27763 1.87132 0.894043 4.59838L3.68674 6.7504C4.35302 4.77187 6.21351 3.30405 8.40665 3.30405Z"
                      fill="#E94235"
                    />
                  </svg>
                </div>
                {showPayComIFrame && (
                  <>
                    <div
                      className={"mt-3"}
                      dangerouslySetInnerHTML={{
                        __html: activeTermsAndConditions,
                      }}
                    />
                  </>
                )}
              </div>
            </div>
          )}

          {/*#method Apple Pay*/}
          {shouldShowApplePayButton && (
            <div
              onClick={() => toggleExpand("apay")}
              className={"mb-3 lg:mb-6 rounded-lg border border-black/16 py-4 lg:py-5 cursor-pointer"}>
              {/*visible*/}
              <div className={"flex items-center px-3 lg:px-6"}>
                <div className={"text-dark-1 text-sm lg:text-lg leading-5 lg:leading-6 font-medium"}>Apple Pay</div>
                <div className={"ml-auto mr-3"}>
                  <img
                    alt="apple-pay-logo"
                    className={"h-4 lg:h-5 w-auto"}
                    src="/assets/images/subscription-checkout/apple-pay-logo.svg"
                    width={40}
                    height={16}
                  />
                </div>
                <div
                  className={`transition-transform duration-400 ${expandedElement === "apay" ? "rotate-180" : "rotate-0"}`}>
                  <img
                    alt="chevron-down"
                    src="/assets/images/subscription-checkout/chevron-down.svg"
                    className={"size-4"}
                    width={16}
                    height={16}
                  />
                </div>
              </div>
              {/*expand*/}
              <div
                className={`px-3 transition-all duration-400 ease-in-out overflow-hidden ${expandedElement === "apay" ? "opacity-100 max-h-[1024px] pt-6 mt-4 border-t border-black/8" : "opacity-0 max-h-0 pt-0 mt-0 border-0"}`}>
                <div
                  onClick={() => startApmPayment(() => setShouldSubmitApplyPayPayment(true))}
                  className="flex h-[48px] px-[16px] py-[8px] justify-center items-center gap-[3px] self-stretch rounded-[4px] border-[0] border-solid border-[#000] bg-[#000] cursor-pointer relative">
                  <svg width="49" height="20" viewBox="0 0 49 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.35757 3.89145C10.7237 3.89145 11.7701 4.42738 12.497 5.49923L12.4162 5.55044C12.3624 5.5914 12.3052 5.63577 12.2446 5.68356C12.184 5.72453 12.1066 5.78597 12.0124 5.8679C11.9249 5.94299 11.8374 6.03175 11.75 6.13415C11.6625 6.22973 11.5683 6.33897 11.4673 6.46185C11.3731 6.57791 11.2856 6.71446 11.2049 6.87148C11.1308 7.02168 11.0602 7.18211 10.9929 7.35279C10.9323 7.51664 10.8818 7.70439 10.8415 7.91603C10.8078 8.12767 10.791 8.34272 10.791 8.56119C10.791 9.01178 10.865 9.43164 11.0131 9.82079C11.1611 10.2031 11.3294 10.5103 11.5178 10.7424C11.7062 10.9746 11.9148 11.1794 12.1436 11.3569C12.3725 11.5344 12.5441 11.6539 12.6585 11.7153C12.7796 11.7768 12.8637 11.8143 12.9108 11.828C12.8974 11.8826 12.857 12.002 12.7897 12.1864C12.7291 12.3707 12.608 12.654 12.4263 13.0364C12.2513 13.4187 12.0528 13.7805 11.8307 14.1219C11.6154 14.4359 11.437 14.6851 11.2957 14.8694C11.1544 15.0469 10.9761 15.2449 10.7607 15.4634C10.5454 15.6819 10.3199 15.8423 10.0844 15.9447C9.85557 16.0471 9.6133 16.0983 9.35757 16.0983C9.00763 16.0983 8.59376 15.9925 8.11595 15.7808C7.63815 15.5692 7.18726 15.4634 6.76329 15.4634C6.3326 15.4634 5.86152 15.5726 5.35007 15.7911C4.83861 16.0096 4.43147 16.1188 4.12864 16.1188C3.68448 16.1188 3.2807 15.9515 2.9173 15.617C2.56063 15.2825 2.14339 14.7704 1.66559 14.0809C1.18105 13.3777 0.780639 12.5448 0.464346 11.5822C0.154782 10.6127 0 9.66035 0 8.72504C0 7.97406 0.114404 7.28793 0.343212 6.66667C0.57202 6.0454 0.874854 5.54019 1.25171 5.15105C1.62857 4.7619 2.05254 4.46151 2.52362 4.24987C2.99469 4.03823 3.48259 3.93241 3.98731 3.93241C4.36417 3.93241 4.83861 4.04847 5.41063 4.28059C5.98938 4.51272 6.37297 4.62878 6.5614 4.62878C6.72292 4.62878 7.1166 4.50589 7.74246 4.26011C8.36831 4.01434 8.90668 3.89145 9.35757 3.89145ZM8.80238 2.5704C8.53319 2.89811 8.19334 3.17119 7.78283 3.38966C7.37906 3.60812 6.99883 3.71736 6.64216 3.71736C6.56813 3.71736 6.49747 3.71053 6.43018 3.69688C6.40999 3.61495 6.39989 3.51596 6.39989 3.3999C6.39989 3.01075 6.48401 2.62161 6.65225 2.23246C6.8205 1.84332 7.02575 1.50538 7.26802 1.21864C7.55739 0.877283 7.91743 0.593958 8.34812 0.368664C8.78555 0.136542 9.20279 0.0136542 9.59984 0C9.62003 0.0887523 9.63012 0.194572 9.63012 0.31746C9.63012 1.12989 9.35421 1.88087 8.80238 2.5704Z"
                      fill="white"
                    />
                    <path
                      d="M16.8717 1.15719H22.7467C24.2003 1.15719 25.378 1.61802 26.2798 2.53968C27.1883 3.46134 27.6425 4.66633 27.6425 6.15463C27.6425 7.61563 27.1748 8.80355 26.2394 9.71838C25.3107 10.6332 24.1094 11.0906 22.6356 11.0906H19.4761V15.9345H16.8717V1.15719ZM19.4761 3.36918V8.89913H22.0502C22.9856 8.89913 23.709 8.66018 24.2205 8.18228C24.7387 7.70439 24.9978 7.0285 24.9978 6.15463C24.9978 5.25346 24.742 4.56392 24.2306 4.08602C23.7258 3.60812 23.0024 3.36918 22.0603 3.36918H19.4761Z"
                      fill="white"
                    />
                    <path
                      d="M32.522 14.1219C33.2757 14.1219 33.9049 13.9034 34.4096 13.4665C34.9144 13.0227 35.1667 12.4765 35.1667 11.828V10.937L32.6734 11.1009C31.3005 11.1896 30.6141 11.6948 30.6141 12.6165C30.6141 13.0807 30.7891 13.4494 31.139 13.7225C31.4957 13.9887 31.9567 14.1219 32.522 14.1219ZM31.7851 16.1188C30.7083 16.1188 29.8301 15.8116 29.1504 15.1971C28.4707 14.5827 28.1309 13.7703 28.1309 12.7599C28.1309 11.7494 28.4909 10.9575 29.211 10.384C29.9378 9.81055 30.9742 9.48285 32.3201 9.40092L35.1667 9.22683V8.28469C35.1667 7.73169 34.9884 7.30841 34.6317 7.01485C34.2751 6.72128 33.7602 6.5745 33.0873 6.5745C32.5085 6.5745 32.0307 6.67691 31.6539 6.88172C31.277 7.07971 31.0314 7.36644 30.917 7.74194H28.5549C28.6558 6.75201 29.1269 5.96689 29.9681 5.38658C30.816 4.79945 31.8961 4.50589 33.2084 4.50589C34.6216 4.50589 35.7118 4.837 36.479 5.49923C37.2529 6.16146 37.6399 7.08995 37.6399 8.28469V15.9345H35.2273V14.3984H35.0557C34.7461 14.9377 34.302 15.361 33.7232 15.6682C33.1512 15.9686 32.5052 16.1188 31.7851 16.1188Z"
                      fill="white"
                    />
                    <path
                      d="M40.4197 20C39.9015 20 39.5718 19.9863 39.4304 19.959V17.8802C39.5583 17.9075 39.7871 17.9211 40.1169 17.9211C40.6485 17.9211 41.0691 17.8085 41.3787 17.5832C41.695 17.3579 41.9339 16.9892 42.0954 16.4772L42.2266 15.9857L38.2797 4.73118H41.0254L43.6096 13.4767H43.7812L46.3552 4.73118H49L45.0127 16.2929C44.5483 17.6788 43.9763 18.6414 43.2966 19.1807C42.6237 19.7269 41.6647 20 40.4197 20Z"
                      fill="white"
                    />
                  </svg>
                </div>
                {showPayComIFrame && (
                  <>
                    <div
                      className={"mt-3"}
                      dangerouslySetInnerHTML={{
                        __html: activeTermsAndConditions,
                      }}
                    />
                  </>
                )}
              </div>
            </div>
          )}

          {/*#method Card*/}
          <div
            onClick={() => toggleExpand("cardpay")}
            className={"mb-5 lg:mb-6 rounded-lg border border-black/16 py-4 lg:py-5 cursor-pointer"}>
            {/*visible*/}
            <div className={"flex items-center px-3 lg:px-6"}>
              <div className={"text-dark-1 text-sm lg:text-lg leading-5 lg:leading-6 font-medium"}>Card Payment</div>
              <div className={"ml-auto mr-2"}>
                <img
                  alt="Rename…"
                  className={"size-6"}
                  src="/assets/images/subscription-checkout/mastercard-logo.svg"
                  width={24}
                  height={24}
                />
              </div>
              <div className={"mr-3"}>
                <img
                  alt="visa-logo"
                  className={"h-6 w-auto"}
                  src="/assets/images/subscription-checkout/visa-logo.svg"
                  width={32}
                  height={24}
                />
              </div>
              <div
                className={`transition-transform duration-400 ${expandedElement === "cardpay" ? "rotate-180" : "rotate-0"}`}>
                <img
                  alt="chevron-down"
                  src="/assets/images/subscription-checkout/chevron-down.svg"
                  className={"size-4"}
                  width={16}
                  height={16}
                />
              </div>
            </div>
            {/*expand*/}
            <div
              className={`px-3 transition-all duration-400 ease-in-out overflow-hidden ${expandedElement === "cardpay" ? "opacity-100 max-h-[1024px] mt-4 border-t border-black/8" : "opacity-0 max-h-0 pt-0 mt-0 border-0"}`}>
              {!isPaymentFormLoading && getPaymentIFrameView()}

              {!isPaymentFormLoading && <>{getCheckoutSubmitButton()}</>}

              {showPayComIFrame && (
                <>
                  <div
                    className={"mt-3"}
                    dangerouslySetInnerHTML={{
                      __html: activeTermsAndConditions,
                    }}
                  />
                </>
              )}
            </div>
          </div>

          <div
            className={"my-5"}
            dangerouslySetInnerHTML={{
              __html: paymentPartners,
            }}
          />

          {/*#message*/}
          {!isPaymentFormLoading && (
            <>
              <div className={"flex items-center gap-2 flex-shrink-0 pb-3 justify-center"}>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-[18px] relative max-h-full">
                  <path
                    d="M6 8.25V5.25C6 4.45435 6.31607 3.69129 6.87868 3.12868C7.44129 2.56607 8.20435 2.25 9 2.25C9.79565 2.25 10.5587 2.56607 11.1213 3.12868C11.6839 3.69129 12 4.45435 12 5.25V8.25M3.75 9.75C3.75 9.35218 3.90804 8.97064 4.18934 8.68934C4.47064 8.40804 4.85218 8.25 5.25 8.25H12.75C13.1478 8.25 13.5294 8.40804 13.8107 8.68934C14.092 8.97064 14.25 9.35218 14.25 9.75V14.25C14.25 14.6478 14.092 15.0294 13.8107 15.3107C13.5294 15.592 13.1478 15.75 12.75 15.75H5.25C4.85218 15.75 4.47064 15.592 4.18934 15.3107C3.90804 15.0294 3.75 14.6478 3.75 14.25V9.75ZM8.25 12C8.25 12.1989 8.32902 12.3897 8.46967 12.5303C8.61032 12.671 8.80109 12.75 9 12.75C9.19891 12.75 9.38968 12.671 9.53033 12.5303C9.67098 12.3897 9.75 12.1989 9.75 12C9.75 11.8011 9.67098 11.6103 9.53033 11.4697C9.38968 11.329 9.19891 11.25 9 11.25C8.80109 11.25 8.61032 11.329 8.46967 11.4697C8.32902 11.6103 8.25 11.8011 8.25 12Z"
                    stroke="#898994"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <div className={"text-[10px] lg:text-xs leading-3 lg:leading-4 font-medium text-[#898994]"}>
                  Your payment information is secure and encrypted
                </div>
              </div>
              <div
                className={
                  "w-[calc(100%-48px)] lg:max-w-[292px] mx-auto border-t border-black/8 flex items-center justify-center flex-wrap pt-3 lg:pt-4 gap-3.5"
                }>
                <img
                  alt="gray-paycom"
                  src="/assets/images/subscription-checkout/gray/gray-paycom.svg"
                  className={"h-6 w-auto"}
                  width={52}
                  height={24}
                />
                <img
                  alt="gray-trustly"
                  src="/assets/images/subscription-checkout/gray/gray-trustly.svg"
                  className={"h-6 w-auto"}
                  width={66}
                  height={24}
                />
                <img
                  alt="gray-visa"
                  src="/assets/images/subscription-checkout/gray/gray-visa.svg"
                  className={"h-6 w-auto"}
                  width={32}
                  height={10}
                />
                <img
                  alt="gray-mastercard"
                  src="/assets/images/subscription-checkout/gray/gray-mastercard.svg"
                  className={"h-6 w-auto"}
                  width={26}
                  height={17}
                />
                <img
                  alt="gray-revolut"
                  src="/assets/images/subscription-checkout/gray/gray-revolut.svg"
                  className={"h-6 w-auto"}
                  width={47}
                  height={11}
                />
                <img
                  alt="gray-pcidss"
                  src="/assets/images/subscription-checkout/gray/gray-pcidss.svg"
                  className={"h-6 w-auto"}
                  width={40}
                  height={16}
                />
                <img
                  alt="gray-secure"
                  src="/assets/images/subscription-checkout/gray/gray-secure.svg"
                  className={"h-6 w-auto"}
                  width={48}
                  height={16}
                />
              </div>
            </>
          )}
        </div>
      </>
    );
  };

  const getDesktopView = () => (
    <article className="mainSection mx-auto flex px-[1.5rem]">
      <section className="leftSection mt-12 w-[60%] flex">
        <div className="max-w-[480px]">
          {isLoading ? (
            <Skeleton
              count={1}
              inline
              highlightColor="#fff"
              containerClassName="flex flex-col w-full h-[500px]"
              className="h-full"
            />
          ) : (
            <>
              <div className="min-h-28">
                <h3 className="normal-case text-left text-2xl font-semibold leading-[1.875rem] !mb-0">
                  Subscribe to BOTB Pass - {packageData?.name}
                </h3>
                <div className="flex items-center mt-2">
                  <span className="leading-[3rem] text-black font-jost text-[2.5rem] font-semibold">
                    £{currentFrequencyPlan?.unit_amount / 100}
                  </span>
                  <span className="leading-[1.625rem] text-[#696971] font-jost text-xl font-medium">
                    /{currentFrequencyPlan?.interval}
                  </span>
                </div>
                <div
                  className={`text-gray-1 font-jost text-[13px] font-normal lg:text-base lg:leading-4.5 ${currentFrequencyPlan?.interval === "month" ? "hidden" : ""}`}>
                  {currentFrequencyPlan?.interval === "year" && <s>£{monthlyPlan.unit_amount / 100}</s>}{" "}
                  <span className={"text-primary"}>{currentFrequencyPlan?.metadata["monthly_price_card"]}</span> / month
                  billed annually
                </div>
              </div>
              <div className="text-dark-1 font-jost text-base leading-snug font-semibold mt-8">
                BOTB Pass - {packageData?.name} £{currentFrequencyPlan?.unit_amount / 100}
              </div>
              <div className="text-gray-1 font-jost text-base font-normal mt-4 w-[480px]">
                {packageData?.description}
              </div>
              <div className="text-gray-1 text-base font-normal mt-5 font-jost">
                Billed {currentFrequencyPlan?.interval === "year" ? "yearly" : "monthly"}
              </div>
              <div className="flex flex-col w-[480px] mt-8">
                {!isPaymentDone && frequencyPlanSelectedOnSubscriptionPage?.interval === "month" && (
                  <div className="bg-[#F4F4F4] rounded-[4px] flex justify-between items-center min-h-[56px] px-5 py-3">
                    <div className="flex gap-3 items-center">
                      <div
                        className={`relative flex w-[39px] h-[24px] py-[1.5px] px-[3px] items-center rounded-[75px] ${isYearlySwitchOn ? "bg-[#28BC31]" : "bg-[rgba(29,27,32,0.12)]"} ${!isPaymentCheckoutLoading ? "cursor-pointer" : "cursor-not-allowed"}`}
                        onClick={togglePlanFrequency}>
                        <div
                          className={`rounded-full bg-[#FEF7FF] absolute w-[18px] h-3/4 ${isYearlySwitchOn ? "right-1" : "left-1"}`}></div>
                      </div>
                      <div className="flex items-center justify-center bg-[#CBF4C9] py-1 px-[6px] rounded-[4px]">
                        <span className="text-[#1C5020] font-jost text-[14px] font-medium">
                          Save {frequencyPlanSelectedOnSubscriptionPage?.metadata?.["upsell_discount_value_switch"]}
                        </span>
                      </div>
                      <span className="text-[#696971] font-jost text-[14px] font-normal">with annual billing</span>
                    </div>
                    <span className="text-[#1C5020] font-jost text-[14px] font-semibold">
                      {`${getYearlyMonthlyPriceCardValue()}/month`}
                    </span>
                  </div>
                )}
                {isPaymentDone ? (
                  <>
                    <hr className="my-4" />
                    {getTotalPaidDetails()}
                  </>
                ) : (
                  <>
                    {getPlanPriceDetails()}
                    {bonusCodeHtml()}
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </section>
      <section className="rightSection shadow-[-15px_4px_20px_-10px_rgba(0,0,0,0.10)] w-[40%] relative">
        {isPaymentDone ? (
          getOrderCompleteView()
        ) : (
          <div className={`${showPayComIFrame ? "pb-10" : "pb-5"}  bg-[#FFF] mt-12 max-w-[480px] ml-[30px] relative`}>
            {isPaymentCheckoutLoading && (
              <div className="absolute inset-0 bg-white bg-opacity-80 flex items-center justify-center z-10 rounded-lg">
                <div className="flex flex-col items-center gap-3">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#FF8200]"></div>
                  <span className="text-[#696971] font-jost text-sm font-medium">Updating payment...</span>
                </div>
              </div>
            )}

            <>{showPayComIFrame && payComIframeData && getHeadlessPaymentView()}</>

            {!showPayComIFrame && <div className="flex flex-col items-center">{getUserEmailInputView()}</div>}
          </div>
        )}
      </section>
    </article>
  );

  const getMobileView = () => (
    <section className={`flex flex-col items-center relative ${isPaymentDone ? "" : "pt-10 px-3"}`}>
      {isLoading ? (
        <Skeleton
          count={1}
          inline
          highlightColor="#fff"
          containerClassName="flex flex-col w-full h-[500px]"
          className="h-full"
        />
      ) : (
        <>
          {!isPaymentDone && (
            <>
              <div className="min-h-24">
                <h4 className={"normal-case text-base leading-snug font-semibold !mb-0"}>
                  Subscribe to BOTB Pass - {packageData?.name}
                </h4>
                <div className="flex items-end mt-1 justify-center">
                  <span className="font-jost text-[28px] justify-start text-black text-3xl font-bold leading-8">
                    £{currentFrequencyPlan?.unit_amount / 100}
                  </span>
                  <span className="text-[#696971] font-jost justify-start text-Text-Content-Tertiary text-base font-medium leading-snug">
                    /{currentFrequencyPlan?.interval}
                  </span>
                </div>
                <div
                  className={`text-gray-1 font-jost text-[13px] font-normal text-center lg:text-base lg:leading-4.5 ${currentFrequencyPlan?.interval === "month" ? "hidden" : ""}`}>
                  {currentFrequencyPlan?.interval === "year" && <s>£{monthlyPlan.unit_amount / 100}</s>}{" "}
                  <span className={"text-primary"}>{currentFrequencyPlan?.metadata["monthly_price_card"]}</span> / month
                  billed annually
                </div>
              </div>
              <Button
                className="flex py-[7px] px-3 items-center gap-2 rounded-[4px] bg-[#F6F6F6] self-center"
                text=""
                onClick={() => setShowFullPlanDetails(true)}>
                <>
                  <span className="text-[12px] font-medium font-jost text-[#696971]">View Details</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M4 6L8 10L12 6"
                      stroke="#696971"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </>
              </Button>
              {frequencyPlanSelectedOnSubscriptionPage.interval === "month" && (
                <div className="bg-[#F4F4F4] rounded-[4px] flex justify-between items-center h-[44px] px-[15px] mt-4 w-full">
                  <div className="flex gap-2 items-center">
                    <div
                      className={`cursor-pointer relative flex w-[40px] h-[22.4px] py-[1.4px] px-[2.8px] items-center rounded-[75px] ${isYearlySwitchOn ? "bg-[#28BC31]" : "bg-[rgba(29,27,32,0.12)]"}`}
                      onClick={togglePlanFrequency}>
                      <div
                        className={`rounded-full bg-[#FEF7FF] absolute w-[16.8px] h-3/4 ${isYearlySwitchOn ? "right-[2px]" : "left-[2px]"}`}></div>
                    </div>
                    <div className="flex items-center justify-center bg-[#CBF4C9] py-1 px-[6px] rounded-[4px]">
                      <span className="text-[#1C5020] font-jost text-[12px] font-medium">
                        Save {frequencyPlanSelectedOnSubscriptionPage?.metadata["upsell_discount_value_switch"]}
                      </span>
                    </div>
                    <span className="text-[#696971] font-jost text-[12px] font-normal">with annual billing</span>
                  </div>
                  <span className="text-[#1C5020] font-jost text-[12px] font-semibold">
                    {`${getYearlyMonthlyPriceCardValue()}/month`}
                  </span>
                </div>
              )}

              {bonusCodeHtml()}

              {/*TOP SPACING*/}
              <div className="w-full pt-8 relative">
                {isPaymentFormLoading && (
                  <div className="absolute inset-0 bg-white bg-opacity-80 flex items-center justify-center z-10 rounded-[4px]">
                    <div className="flex flex-col items-center gap-2">
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-[#FF8200]"></div>
                      <span className="text-[#696971] font-jost text-xs font-medium">Updating payment...</span>
                    </div>
                  </div>
                )}

                <div className={`flex flex-col gap-6 ${showPayComIFrame ? "visible" : "invisible"}`}>
                  <>{showPayComIFrame && payComIframeData && getHeadlessPaymentView()}</>
                  {showPayComIFrame && (
                    <>
                      <div
                        className="text-[#696971] text-[12px] font-normal text-center"
                        dangerouslySetInnerHTML={{
                          __html: activeTermsAndConditions,
                        }}
                      />
                    </>
                  )}
                </div>
                {!showPayComIFrame && (
                  <div className={`flex flex-col items-center ${showPayComIFrame ? "invisible" : "visible"}`}>
                    {getUserEmailInputView()}
                  </div>
                )}
                <div
                  className="mt-10 w-full pb-4"
                  dangerouslySetInnerHTML={{
                    __html: paymentPartners,
                  }}
                />
              </div>
              {showPlanFullDetails && (
                <div className="absolute rounded-b-lg bg-white px-4 py-6 z-[100] w-full top-0 border">
                  <div className="flex gap-2 items-center justify-end" onClick={() => setShowFullPlanDetails(false)}>
                    <span className="text-[#696971] text-[14px] font-medium">Close</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path
                        d="M12 10L8 6L4 10"
                        stroke="#696971"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="mt-8 flex justify-between">
                    <span className="text-[#28282B] font-jost text-[14px] font-bold">
                      BOTB Pass - {packageData?.name}
                    </span>
                    <span className="text-[#28282B] font-jost text-[14px] font-semibold"></span>£
                    {currentFrequencyPlan?.unit_amount / 100}
                  </div>
                  <div className="text-[#696971] font-jost text-[12px] font-normal mt-4">
                    {packageData?.description}
                  </div>
                  <div className="text-[#696971] text-[12px] font-normal mt-4 font-jost">
                    Billed {currentFrequencyPlan?.interval === "year" ? "yearly" : "monthly"}
                  </div>
                  {/*<hr className="my-4" />*/}
                  <div className="flex flex-col">{getPlanPriceDetails()}</div>
                </div>
              )}
            </>
          )}
          {isPaymentDone && (
            <div className="bg-white py-2 w-full">
              <div className="flex flex-col gap-2 relative">
                <div className="flex justify-between items-center">
                  <span className="text-[#696971] font-jost text-[14px] font-semibold pl-3">Order complete</span>
                  <span
                    className="pr-3 flex gap-1 text-[#696971] font-jost text-[14px] font-normal underline items-center"
                    onClick={() => setShowOrderDetails(isOpen => !isOpen)}>
                    <span>{showOrderDetails ? "Close" : "Details"}</span>
                    {showOrderDetails ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                        <path
                          d="M1 5L5 1L9 5"
                          stroke="#696971"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M4 6L8 10L12 6"
                          stroke="#696971"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                  </span>
                </div>
                <hr />
                <div className="px-3"> {getOrderCompleteView()}</div>
                {showOrderDetails && (
                  <div className="absolute bg-white z-[100] px-4 rounded-b-lg border py-3 top-[30px]">
                    <div className="mt-5 flex justify-between">
                      <span className="text-[#28282B] font-jost text-[14px] font-bold">
                        BOTB Pass - {packageData?.name}
                      </span>
                      <span className="text-[#28282B] font-jost text-[14px] font-semibold"></span>£
                      {currentFrequencyPlan?.unit_amount / 100}
                    </div>
                    <div className="text-[#696971] font-jost text-[12px] font-normal mt-5">
                      {packageData?.description}
                    </div>
                    <div className="text-[#696971] text-[12px] font-normal mt-5 font-jost">
                      Billed {currentFrequencyPlan?.interval === "year" ? "yearly" : "monthly"}
                    </div>
                    <hr className="my-4" />
                    <div className="flex flex-col gap-4">{getTotalPaidDetails()}</div>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </section>
  );

  const getOrderCompleteView = () => (
    <div className="flex justify-center lg:pt-20 pt-5 lg:pl-[1.875rem]">
      <div className="flex flex-col">
        <h1 className="normal-case lg:uppercase lg:text-[2rem] text-xl font-semibold lg:font-normal !mb-0">
          🎉 Congratulations!
        </h1>
        <div className="flex mt-2 lg:mt-3 justify-center gap-1">
          <span className="text-[#4C4C52] font-jost lg:text-xl xs:text-[14px] font-bold">
            BOTB Pass - {packageData?.name}
          </span>
          <span className="text-[#4C4C52] font-jost lg:text-xl xs:text-[14px] font-normal">is now active</span>
        </div>
        <div className="flex flex-col py-6 px-5 rounded-lg bg-[#F5F5F5] max-w-[600px] lg:mt-12 mt-6">
          {isUserAuthenticated ? (
            <>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
                <path
                  d="M13 1V3M13 7V9M13 13V15M3 1H17C17.5304 1 18.0391 1.21071 18.4142 1.58579C18.7893 1.96086 19 2.46957 19 3V6C18.4696 6 17.9609 6.21071 17.5858 6.58579C17.2107 6.96086 17 7.46957 17 8C17 8.53043 17.2107 9.03914 17.5858 9.41421C17.9609 9.78929 18.4696 10 19 10V13C19 13.5304 18.7893 14.0391 18.4142 14.4142C18.0391 14.7893 17.5304 15 17 15H3C2.46957 15 1.96086 14.7893 1.58579 14.4142C1.21071 14.0391 1 13.5304 1 13V10C1.53043 10 2.03914 9.78929 2.41421 9.41421C2.78929 9.03914 3 8.53043 3 8C3 7.46957 2.78929 6.96086 2.41421 6.58579C2.03914 6.21071 1.53043 6 1 6V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1Z"
                  stroke="black"
                  stroke-opacity="0.8"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="mt-3 text-[#4C4C52] font-jost lg:text-[16px] xs:text-[13px] font-normal">
                Your tickets are on their way into current competitions. You can view your entries anytime in the{" "}
                <span className="text-[#4C4C52] font-jost lg:text-[16px] xs:text-[13px] font-bold">
                  Wallet section{" "}
                </span>
                of <span className="text-[#4C4C52] font-jost lg:text-[16px] xs:text-[13px] font-bold">My account</span>.
              </span>
            </>
          ) : (
            <>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 15.0003L15 9.00031M11 6.00031L11.463 5.46431C12.4008 4.52663 13.6727 3.99991 14.9989 4C16.325 4.00009 17.5968 4.527 18.5345 5.46481C19.4722 6.40261 19.9989 7.6745 19.9988 9.00066C19.9987 10.3268 19.4718 11.5986 18.534 12.5363L18 13.0003M13.0001 18.0003L12.6031 18.5343C11.6544 19.4725 10.3739 19.9987 9.03964 19.9987C7.70535 19.9987 6.42489 19.4725 5.47614 18.5343C5.0085 18.0719 4.63724 17.5213 4.38385 16.9144C4.13047 16.3076 4 15.6565 4 14.9988C4 14.3412 4.13047 13.69 4.38385 13.0832C4.63724 12.4763 5.0085 11.9257 5.47614 11.4633L6.00014 11.0003"
                  stroke="black"
                  stroke-opacity="0.8"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div className="flex mt-3">
                <span className="text-[#4C4C52] font-jost lg:text-[16px] xs:text-[13px] font-normal">
                  We've linked your BOTB Pass - {packageData?.name} plan to{" "}
                  <span className="text-[#4C4C52] font-jost lg:text-[16px] xs:text-[13px] font-bold">
                    {userEmail}
                    <span className="text-[rgba(0, 0, 0, 0.80)] font-normal">.</span>
                  </span>
                </span>
              </div>
              <span className="text-[#4C4C52] font-jost lg:text-[16px] xs:text-[13px] font-normal mt-4">
                If you already have a BOTB account with this email, you can{" "}
                <a
                  className="text-[#5F8EFF] font-jost lg:text-[16px] xs:text-[13px] font-medium underline"
                  href="/login"
                  target="_blank">
                  Log in
                </a>{" "}
                to manage your subscription and view your entries.
              </span>
              <span className="text-[#4C4C52] font-jost lg:text-[16px] xs:text-[13px] font-normal mt-4">
                If not, we’ve created one account for you — check your inbox for the activation link to finish setting
                things up.{" "}
                <span className="text-[#4C4C52] font-jost lg:text-[16px] xs:text-[13px] font-bold">
                  You must complete any outstanding information for your account in order to be able to be eligible to
                  receive any prize, in accordance with{" "}
                  <a
                    href="/terms"
                    target="_blank"
                    className="text-[#5F8EFF] font-jost lg:text-[16px] xs:text-[13px] font-medium underline">
                    our terms
                  </a>
                  .
                </span>
              </span>
              <span className="text-[#4C4C52] font-jost lg:text-[16px] xs:text-[13px] font-normal mt-4">
                We will use this email address to manage our communications with you and to remind you of any upcoming
                draws that you need to enter manually via your account.
              </span>
              <span className="text-[#4C4C52] font-jost lg:text-[16px] xs:text-[13px] font-normal mt-4">
                If you already have an active subscription on this email address, we will refund the charged amount in
                few working days.
              </span>
            </>
          )}
        </div>
        <div className="flex lg:mt-4.5 mt-2 gap-2 items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 9H12.01M11 12H12V16H13M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="text-[#898994] font-jost lg:text-[16px] xs:text-[13px]">
            If you need help, please{" "}
            <a
              className="text-[#5F8EFF] font-jost lg:text-[16px] xs:text-[13px] font-medium underline"
              href="/contact-us"
              target="_blank">
              Contact support.
            </a>
          </span>
        </div>
        <div className="flex flex-col lg:mt-[3.25rem] mt-8">
          <FeaturedCompetitions headerText="Next Ending Competitions" />
        </div>
        <div
          className="mt-6 pb-4"
          dangerouslySetInnerHTML={{
            __html: paymentPartners,
          }}
        />
      </div>
    </div>
  );

  const facebookTrackingEvent = () => {
    if (window.fbq && isFacebookSubscribeEventEnabled) {
      // Execute Facebook tracking for standard subscribe event
      window.fbq("track", "Subscribe", { value: "0.00", currency: "GBP", predicted_ltv: "0.00" });
    }
  };

  return (
    <>
      <header className="sticky top-0 bg-white z-[1003] botb-pass-header">
        <Header renderModalComponentHere={false} isBotBPassHeader={!isPaymentDone} />
      </header>
      {windowInnerWidth >= DEVICE_RESOLUTION.Desktop ? getDesktopView() : getMobileView()}
    </>
  );
};

export default SubscriptionCheckout;
